import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const Recaptcha = require("react-recaptcha");
import { useFormik } from "formik";
import * as Yup from "yup";
import { formDataGenerator } from "../../../../utils/common";
import {
  getCategory,
  getSubjects,
  clearGetSubjects,
  sendOtp,
  getCsrfToken,
  postWriteUsSubmit,
} from "./action";
import "./styleCallUs.scss";
import Modal from "react-modal";
import SuccessModal from "./SuccessModal";

const WriteToModal = (props) => {
  const {
    open,
    onClose,
    getCsrfToken,
    token,
    getCategory,
    categoryData,
    subjectData,
    getSubjects,
    clearGetSubjects,
    sendOtp,
    otpRes,
    postWriteUsSubmit,
    writeUs,
  } = props;
  useEffect(() => {
    getCsrfToken();
  }, []);

  const [seconds, setSeconds] = useState(0);
  const [enableResendBtn, setEnableResendBtn] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const emailPattern = /^\w+([-+.']\w+)*@[A-Za-z\d]+\.com$|.in$/;
  const [category, setCategory] = useState();
  const [subject, setSubject] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [application, setApplication] = useState();
  const [address, setAddress] = useState();
  const [mobile, setMobile] = useState();
  const [otp, setOtp] = useState();
  const [message, setMessage] = useState();
  const [otpValidation, setOtpValidation] = useState();
  const [successModalShow, setSuccessModalShow] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState(""); 

  useEffect(() => {
    if (writeUs && writeUs.statusCode === 3) {
      setOtpValidation(writeUs.message);
    }

    if (writeUs && writeUs.statusCode === 2) {
      setOtpValidation(writeUs.message);
    }

    if (writeUs && writeUs.statusCode === 1) {
      onClose();
      setSuccessModalShow(true);
      handleResetFn();
    }
  }, [writeUs]);

  const clickSendOtp = () => {
    if (mobile) {
      setIsOtpSent(true);
      let params = {
        type: "write",
        mobileNumber: mobile,
      };
      var form_data = new FormData();

      form_data.append("type", "write");
      // formik.resetForm()
      sendOtp(formDataGenerator(params));
      setEnableResendBtn(true);
      //  setSeconds(30)
    }
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const otpRegEx = /^[0-9]*$/;
  const firstlastRegExp = /^[A-Za-z]+$/;
  const validationSchema = Yup.object().shape({
    category: Yup.string().required("Please select category details"),
    subject: Yup.string().required("Please select subject details"),
    firstName: Yup.string().matches(firstlastRegExp, "Please Enter your First Name").required("Please Enter your First Name details"),
    lastName: Yup.string().matches(firstlastRegExp, "Please Enter your Last Name").required("Please Enter your Last Name details"),
    application: Yup.string().required("Please Enter your application details"),
    address: Yup.string()
      .email("email is not correct")
      .matches(emailPattern,'Incorrect email')
      .required("Please Enter your address details"),
    mobile: Yup.string()
      .matches(phoneRegExp, "Mobile number is not valid")
      .required("Please enter mobile number")
      .min(10, "Mobile must be at least 10 characters")
      .max(10, "Mobile must not exceed 10 characters"),
    otp: Yup.string().required("Please Enter your Otp details"),
    message: Yup.string().required("Please Enter your message details"),
  });
  const formik = useFormik({
    initialValues: {
      category: "",
      subject: "",
      firstName: "",
      lastName: "",
      application: "",
      address: "",
      mobile: "",
      otp: "",
      message: "",
      type: "write",
    },
    validationSchema,
    // validateOnChange: false,
    // validateOnBlur: false,
    onSubmit: (data) => {
      let payload = {
        category: data.category,
        subject: data.subject,
        firstName: data.firstName,
        lastName: data.lastName,
        application: data.application,
        email: data.address,
        mobileNumber: data.mobile,
        otpCode: data.otp,
        message: data.message,
        type: "write",
      };
      postWriteUsSubmit(formDataGenerator(payload), token);
    },
  });

  const handleSelectChange = (e) => {
    const selectedId = e.target.value;
    const selectedCat = categoryData && categoryData.categories.find(
      (cat) => cat.id === selectedId
    );
    setSelectedTitle(selectedCat ? selectedCat.title : ""); 
    formik.handleChange(e); 
  };

  useEffect(() => {
    if (selectedTitle == 'Cybersecurity / Technology Issues' && subjectData?.length > 0) {
      formik.setFieldValue("subject", subjectData[0].id, false);
    }
  }, [formik.values.category, subjectData]);

  const handleClose = () => {
    onClose();
    handleResetFn();
  };

  useEffect(() => {
    if (formik.values.category) {
      setCategory(formik.values.category);
      getSubjects(formik.values.category);
      formik.setFieldValue("subject", '', false); 
    }
  }, [formik.values.category]);

  useEffect(() => {
    if (formik.values.subject) {
      setSubject(formik.values.subject);
    }
  }, [formik.values.subject]);
  useEffect(() => {
    if (formik.values.firstName) {
      setFirstName(formik.values.firstName);
    }
  }, [formik.values.firstName]);
  useEffect(() => {
    if (formik.values.lastName) {
      setFirstName(formik.values.lastName);
    }
  }, [formik.values.lastName]);
  useEffect(() => {
    if (formik.values.application) {
      setApplication(formik.values.application);
    }
  }, [formik.values.application]);
  useEffect(() => {
    if (formik.values.address) {
      setAddress(formik.values.address);
    }
  }, [formik.values.address]);
  useEffect(() => {
   
    if (formik.values.mobile) {
      setMobile(formik.values.mobile);
      setOtp('');
      setEnableResendBtn(false);
    }
  }, [formik.values.mobile]);
  useEffect(() => {
    if (formik.values.otp) {
      setOtp(formik.values.otp);
    }
  }, [formik.values.otp]);
  useEffect(() => {
    if (formik.values.message) {
      setMessage(formik.values.message);
    }
  }, [formik.values.message]);

  useEffect(() => {
    getCategory && getCategory();
  }, []);

  const handleSuccessModal = () => {
    setSuccessModalShow(false);
    onClose();
  };

  const handleResetFn = () => {
    clearGetSubjects();
    setSelectedTitle("");
    formik.setFieldValue("subject", '', false);
    formik.resetForm();
    setOtpValidation();
    setOtp('');
    setEnableResendBtn(false);
    setMobile();
  }

  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={handleClose}
        contentLabel="Example Modal"
        className="writeusmodal"
      >
        <div>
          <div className="d-flex align-items-center justify-content-between modal-title">
            <span className=" d-flex align-items-center">
              <img
                src="https://hdfcmf-website-dev.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/contact-us/write-to-us.svg"
                alt=""
              />
              <span className="writetous ms-3">Write To Us</span>
            </span>
            <img
              src="/images/New/red-arrow-close.svg"
              width={25}
              height={25}
              alt="close"
              onClick={handleClose}
              className="cursorp"
            />
          </div>

          <div className="container mt-4">
            <p>
            We have received your message{selectedTitle && selectedTitle == 'Cybersecurity / Technology Issues'? "" : " We will revert back to you within next 2 days except on weekends and public holidays"}.
            </p>
            <div className="row mt-3">
              <form onSubmit={formik.handleSubmit} className="p-0 writeform">
                <div className="col-md-6 mb-4">
                  {/* <Form.Label htmlFor="select">Category</Form.Label> */}
                  <select
                    aria-label="Default select example"
                    name="category"
                    onChange={handleSelectChange}
                    value={formik.values.category}
                    className={
                      "form-select" +
                      (formik.errors.category && formik.touched.category
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option value="" disabled selected >Category</option>
                    {categoryData &&
                      categoryData.categories.map((cat, index) => (
                        <option value={cat.id}>{cat.title}</option>
                      ))}
                  </select>
                  <div className="invalid-feedback">
                    {formik.errors.category && formik.touched.category
                      ? formik.errors.category
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  {/* <Form.Label htmlFor="select1">Subject</Form.Label> */}
                  <select
                    aria-label="Default select example"
                    name="subject"
                    onChange={formik.handleChange}
                    value={formik.values.subject}
                    className={
                      "form-select" +
                      (formik.errors.subject && formik.touched.subject
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option value="" disabled selected >Subject</option>
                    {subjectData &&
                      subjectData.map((sub, index) => (
                        <option value={sub.id}>{sub.title}</option>
                      ))}
                  </select>
                  <div className="invalid-feedback">
                    {formik.errors.subject && formik.touched.subject
                      ? formik.errors.subject
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <input
                    type="text"
                    placeholder="First Name*"
                    name="firstName"
                    onChange={formik.handleChange}
                    value={formik.values.firstName}
                    className={
                      "invalid form-control" +
                      (formik.errors.firstName && formik.touched.firstName
                        ? " is-invalid"
                        : "")
                    }
                    autoComplete='off'
                    aria-autocomplete="none"
                  />
                  <div className="invalid-feedback">
                    {formik.errors.firstName && formik.touched.firstName
                      ? formik.errors.firstName
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <input
                    type="text"
                    placeholder="Last Name*"
                    name="lastName"
                    onChange={formik.handleChange}
                    value={formik.values.lastName}
                    className={
                      "invalid form-control" +
                      (formik.errors.lastName && formik.touched.lastName
                        ? " is-invalid"
                        : "")
                    }
                    autoComplete='off'
                    aria-autocomplete="none"
                  />
                  <div className="invalid-feedback">
                    {formik.errors.lastName && formik.touched.lastName
                      ? formik.errors.lastName
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <input
                    type="text"
                    placeholder="Folio/Application Number*"
                    name="application"
                    onChange={formik.handleChange}
                    value={formik.values.application}
                    className={
                      "invalid form-control" +
                      (formik.errors.application && formik.touched.application
                        ? " is-invalid"
                        : "")
                    }
                    autoComplete='off'
                    aria-autocomplete="none"
                  />
                  <div className="invalid-feedback">
                    {formik.errors.application && formik.touched.application
                      ? formik.errors.application
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <input
                    type="text"
                    placeholder="Email Address*"
                    name="address"
                    onChange={formik.handleChange}
                    value={formik.values.address}
                    className={
                      "invalid form-control" +
                      (formik.errors.address && formik.touched.address
                        ? " is-invalid"
                        : "")
                    }
                    autoComplete='off'
                    aria-autocomplete="none"
                  />
                  <div className="invalid-feedback">
                    {formik.errors.address && formik.touched.address
                      ? formik.errors.address
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="input-group contantnum">
                    <input
                      type="text"
                      placeholder="Contact Number*"
                      name="mobile"
                      className={
                        "invalid form-control" +
                        (formik.errors.mobile && formik.touched.mobile
                          ? " is-invalid"
                          : "")
                      }
                      onChange={formik.handleChange}
                      value={formik.values.mobile}
                      autoComplete='off'
                      aria-autocomplete="none"
                    />
                    {mobile && mobile.length === 10 ? (
                      <span className="resetOtp" onClick={clickSendOtp} disabled>
                        {!enableResendBtn ? "Send OTP" : "Resend OTP"}
                      </span>
                    ) : (
                      <span className="resetOtpDisable">
                        {!enableResendBtn ? "Send OTP" : "Resend OTP"}
                      </span>
                    )}
                    <div className="invalid-feedback">
                      {formik.errors.mobile && formik.touched.mobile
                        ? formik.errors.mobile
                        : null}
                      {}
                    </div>
                  </div>
                  {/* <Recaptcha
                    ref={e => this.recaptchaInstance = e}
                    sitekey="6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4pointerYOW40tuX"
                    render="explicit"
                    verifyCallback={this.verifyCallback}
                /> */}
                </div>
                <div className="col-md-6 mb-4">
                  <div className="input-group">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      name="otp"
                      onChange={formik.handleChange}
                      value={formik.values.otp}
                      className={
                        "invalid form-control" +
                        (formik.errors.otp && formik.touched.otp
                          ? " is-invalid"
                          : "")
                      }
                      autoComplete='off'
                      aria-autocomplete="none"
                    />

                    <div className="invalid-feedback">
                      {formik.errors.otp && formik.touched.otp
                        ? formik.errors.otp
                        : null}
                    </div>
                    <div className="mt-1 text-danger">{otpValidation}</div>
                  </div>
                </div>
                <div className="col-md-12 mb-4">
                  <div
                    className="input-group"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <input
                      as="textarea"
                      rows={4}
                      placeholder="Enter message here"
                      name="message"
                      onChange={formik.handleChange}
                      value={formik.values.message}
                      className={
                        "invalid form-control" +
                        (formik.errors.message && formik.touched.message
                          ? " is-invalid"
                          : "")
                      }
                      autoComplete='off'
                      aria-autocomplete="none"
                    />
                    <div className="invalid-feedback">
                      {formik.errors.message && formik.touched.message
                        ? formik.errors.message
                        : null}{" "}
                      {otpValidation}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 text-center writetous">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={
                      !(
                        mobile &&
                        mobile.length === 10 &&
                        otp &&
                        otp.length === 6
                      )
                    }
                  >
                    Submit
                  </button>
                  <p className="orcls my-2">or</p>
                  <a
                    href="#"
                    onClick={handleResetFn}
                    className="reset mb-3"
                  >
                    RESET
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
      <SuccessModal open={successModalShow} onClose={handleSuccessModal} />
    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.stickBar.token,
  categoryData: state.stickBar.category,
  subjectData: state.stickBar.subject,
  otpRes: state.stickBar,
  writeUs: state.stickBar.writeUs,

  // .whatWeStandForMsg.whatWeStandFor.data[0]
});

const mapDispatchToProps = (dispatch) => ({
  getCategory: bindActionCreators(getCategory, dispatch),
  getSubjects: bindActionCreators(getSubjects, dispatch),
  clearGetSubjects: bindActionCreators(clearGetSubjects, dispatch),
  sendOtp: bindActionCreators(sendOtp, dispatch),
  getCsrfToken: bindActionCreators(getCsrfToken, dispatch),
  postWriteUsSubmit: bindActionCreators(postWriteUsSubmit, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WriteToModal);
